import { Trans } from '@lingui/react';
import { GqlMeetingHeldKind } from '../../../graphql/base-types.graphql';

export const MeetingHeldKindHuman = ({ children }: { children: GqlMeetingHeldKind }) => {
  switch (children) {
    case GqlMeetingHeldKind.PerCapsulam: {
      return <Trans id="Per Capsulam" />;
    }
    case GqlMeetingHeldKind.Phone: {
      return <Trans id="Phone" />;
    }
    case GqlMeetingHeldKind.Physical: {
      return <Trans id="Physical" />;
    }
    case GqlMeetingHeldKind.PhysicalAndPhone: {
      return <Trans id="Physical and Phone" />;
    }
    default: {
      throw new Error('missing gql meeting held kind');
    }
  }
};
